import React, { useState, useRef, useEffect } from "react";
import "./tpdateRangePicker.scss";
import { Box, Grid } from "@mui/material";
import DatePicker from "react-datepicker";
import calender_icon from "../../globals/assets/Icon metro-calendar (2).svg";
import "react-datepicker/dist/react-datepicker.css";

const TP_DateRange = (props) => {
  const { getdateRange, clearID, startDateProps, endDateProps } = props;
  const datepicker_ref = useRef();
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const openDatePicker = () => {
    let ref = datepicker_ref.current.onInputClick();
    console.log("ref--------->>", ref);
  };
  const clearDateField = () => {
    // let ref = datepicker_ref.current.clear();
    // console.log('ref--------->>', ref);
    setDateRange([startDateProps, endDateProps]);
  };

  useEffect(() => {
    getdateRange(dateRange);
  }, [dateRange]);

  return (
    <>
      <Grid container justifyContent="space-around" id="tp_date_Picker">
        <div className="fs-4 margintop">Select Date</div>
        <div>
          <div className="date_Picker">
            <DatePicker
              ref={datepicker_ref}
              selectsRange={true}
              dateFormat="dd/MM/yyyy"
              startDate={startDate}
              endDate={endDate}
              onChange={(update) => {
                setDateRange(update);
              }}
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholderText={"DD/MM/YYYY-DD/MM/YYYY"}
              monthsShown={2}
            />
            <img src={calender_icon} onClick={openDatePicker} />
          </div>
        </div>
        <div className="cleartext_color" onClick={clearDateField} id={clearID}>
          Clear
        </div>
      </Grid>
    </>
  );
};

export default TP_DateRange;
